<template>
  <section class="bg-[#0B1B33] text-white py-20 fade-in-on-scroll min-h-[300px]" v-stagger-fade>
    <div class="max-w-7xl mx-auto px-4 text-center fade-in-on-scroll" v-scroll-fade>
      <h2 class="text-3xl font-bold mb-12">Why AlgoPilot?</h2>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-10 text-left">
        <InfoCard
          emoji="🎯"
          title="Trader First"
          description="I don’t just code — I trade. Every tool I build comes from real-world market experience."
        />
        <InfoCard
          emoji="⚙️"
          title="Performance Obsessed"
          description="My builds focus on speed, reliability, and clean logic — not bloated features."
        />
        <InfoCard
          emoji="🧠"
          title="Deep MQL5 Knowledge"
          description="Years in the trenches with MQL5. I speak the language fluently — and use it wisely."
        />
      </div>
    </div>
  </section>
</template>

<script>
import InfoCard from '@/components/InfoCard.vue';

export default {
  components: {
    InfoCard
  }
};
</script>
